/**
 * Creates clean string without special HTML entity characters
 * @param {string} html
 * @returns {sting}
 */
const decodeHtml = html => {
  const txt = document.createElement('textarea');
  txt.innerHTML = html;
  return txt.value;
};

export default decodeHtml;
